var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_35766)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_35766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_35766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 44C10.175 44 9.46875 43.7063 8.88125 43.1188C8.29375 42.5312 8 41.825 8 41V19.3C8 18.475 8.29375 17.7688 8.88125 17.1813C9.46875 16.5938 10.175 16.3 11 16.3H14.5V11.5C14.5 8.87167 15.4268 6.63125 17.2803 4.77875C19.1338 2.92625 21.3755 2 24.0053 2C26.6351 2 28.875 2.92625 30.725 4.77875C32.575 6.63125 33.5 8.87167 33.5 11.5V16.3H37C37.825 16.3 38.5312 16.5938 39.1187 17.1813C39.7062 17.7688 40 18.475 40 19.3V41C40 41.825 39.7062 42.5312 39.1187 43.1188C38.5312 43.7063 37.825 44 37 44H11ZM11 41H37V19.3H11V41ZM24.0084 34C25.0695 34 25.975 33.6328 26.725 32.8985C27.475 32.1641 27.85 31.2813 27.85 30.25C27.85 29.25 27.4722 28.3417 26.7166 27.525C25.961 26.7083 25.0527 26.3 23.9916 26.3C22.9305 26.3 22.025 26.7083 21.275 27.525C20.525 28.3417 20.15 29.2583 20.15 30.275C20.15 31.2917 20.5278 32.1667 21.2834 32.9C22.039 33.6333 22.9473 34 24.0084 34ZM17.5 16.3H30.5V11.5C30.5 9.69443 29.8686 8.15972 28.6059 6.89585C27.3431 5.63195 25.8098 5 24.0059 5C22.202 5 20.6667 5.63195 19.4 6.89585C18.1333 8.15972 17.5 9.69443 17.5 11.5V16.3Z",
    fill: "#0BAB47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_35766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b70f429c4575a311c08f305ee0ee2889.svg";
export { ForwardRef as ReactComponent };